// extracted by mini-css-extract-plugin
export var addressFields = "_mx-0";
export var animationContainer = "_mx-1";
export var footer = "_mx-2";
export var lineItems = "_mx-3";
export var modalContent = "_mx-4";
export var orderName = "_mx-5";
export var strong = "_mx-6";
export var warning = "_mx-7";